const Donate = () => {
  return (
    <div>
      <h1>DONOR REGISTRATION PAGE</h1>
    </div>
  )
}

export default Donate
